import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const GarrisonService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/garrison/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),

    formData: async (id, retroactive = false) => {
        let url = `${API_DESPACHO}/garrison`;
        if (id) url += `/${id}`;
        if (retroactive) url += "/retroactive";
        return axios.get(url).then(({data}) => data).catch((err) => { throw err });
    },

    compositionList: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId ?? "");
        return axios.post(`${API_DESPACHO}/garrison/compositionList`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    copy: async (cp) => axios.get(`${API_DESPACHO}/garrison/copy/${cp}`).then(({data}) => data).catch((err) => { throw err }),

    getGarrisonSchedule: async (id) => axios.get(`${API_DESPACHO}/garrison/getGarrisonSchedule/${id}`).then(({data}) => data).catch((err) => { throw err }),

    getListSchedules: async (garrisonId, groups) =>
        axios.get(`${API_DESPACHO}/schedule-garrison/getListSchedules`, {params: {garrisonId, groups}})
            .then(({data}) => data).catch((err) => { throw err }),

    getDispatchStatus: async (garrisonId) =>
        axios.get(`${API_DESPACHO}/dispatch/getDispatchStatus`, {params: {garrisonId}})
            .then(({data}) => data).catch((err) => { throw err }),

    getDispatchHistoryByGarrison: async (garrisonId) =>
        axios.post(`${API_DESPACHO}/garrison/getDispatchHistoryByGarrison`, null, {params: {garrisonId}})
            .then(({data}) => data).catch((err) => { throw err }),

    getGarrisonByIdToView: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/garrison/getGarrisonByIdtoView/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getClosedGarrison: async (garrisonId) =>
        axios.get(`${API_DESPACHO}/garrison/getClosedGarrison/`, {params: {garrisonId}})
            .then(({data}) => data).catch((err) => { throw err }),

    getChangeContingentsGarrisonByDash: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/garrison/getChangeContingentsGarrisonByDash/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    closeGarrison: async (payload) =>
        axios.post(`${API_DESPACHO}/garrison/setCloseGarrison/`, payload).then(({data}) => data).catch((err) => { throw err }),

    setChangeContingents: async (payload) =>
        axios.post(`${API_DESPACHO}/garrison/setChangeContingents/`, payload).then(({data}) => data).catch((err) => { throw err }),

    checkKmByCompositionCloseGarrison: async (compositionId, actualKm) => {
        const formData = new FormData();
        formData.append("compositionId", compositionId);
        formData.append("actualKm", actualKm ?? "");
        return axios.post(`${API_DESPACHO}/vehicle/checkKmByCompositionCloseGarrison/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    fixedLocationByLastPlace: async (placeId) =>
        axios.get(`${API_DESPACHO}/fixed-location-inspection/getByLastPlace/${placeId}`)
            .then(({data}) => data).catch((err) => { throw err }),

    getDateFormattedView: async () =>
        axios.get(`${API_DESPACHO}/configuration/getDateFormattedView`).then(({data}) => data).catch((err) => { throw err }),

    ackGarrisonByMobile: async (garrisonId) =>
        axios.post(`${API_DESPACHO}/garrison/ackGarrison/${garrisonId}`).then(({data}) => data).catch((err) => { throw err }),

    ackPanic: async (garrisonId) =>
        axios.post(`${API_DESPACHO}/garrison/ackPanic/${garrisonId}`).then(({data}) => data).catch((err) => { throw err }),

    setPanic: async (garrisonId) =>
        axios.post(`${API_DESPACHO}/garrison/panic/${garrisonId}`).then(({data}) => data).catch((err) => { throw err }),

    verifyMileageBeforeUpsert: async (model) =>
        axios.post(`${API_DESPACHO}/garrison/verifyMileageBeforeUpsert/`, model, {headers: {"Content-Type": "application/json"}})
            .then((response) => response).catch((err) => { throw err }),

    save: async (model, fixedLocationInspection) =>
        axios.post(`${API_DESPACHO}/garrison`, model, {params: {fixedLocationInspection}})
            .then(({data}) => data).catch((err) => { throw err }),

    update: async (id, model, fixedLocationInspection) =>
        axios.put(`${API_DESPACHO}/garrison/${id}`, model, {params: {fixedLocationInspection}})
            .then(({data}) => data).catch((err) => { throw err }),
};

export default GarrisonService;
